import { createAction, props } from '@ngrx/store';

export const setSelectedOrganization = createAction(
    '[selectedOrganization] Set',
    props<{selectedOrganization: string}>());
